module.exports = __webpack_public_path__ + "img/doc.7397528b.png";